import React, { Fragment, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Input, Textarea, Radio } from "@app/components";
import {
  educationList,
  gradesList,
  subjectOptions,
  teacherPlan,
} from "@app/utils";
import {
  FormFlexWrapper,
  DropdownWrapper,
  Error,
  SelectCustomStyles,
  CommonLabel,
  FlexWrapper,
} from "@app/components/commonStyles";
import SampleFile from "./sample-file";
type Props = {
  errors: any;
  control: any;
  register: any;
  selectedWizard: number;
  planType: string;
};

export default function SubmitContentComponent({
  errors,
  control,
  selectedWizard,
  register,
  planType,
}: Props) {
  const [showSample, setShowSample] = useState<boolean>(false);



  return (
    <Fragment>
      {selectedWizard === 1 && (
        <Fragment>
          <h4 className="form-header text-center mb-3">
            Submit Content and Monetize
          </h4>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <DropdownWrapper>
                <CommonLabel>Education</CommonLabel>
                <Controller
                  as={Select}
                  value="value"
                  name="education"
                  options={educationList}
                  placeholder="Education"
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={""}
                />
                {errors.education && <Error>Please select Education</Error>}
              </DropdownWrapper>
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <DropdownWrapper>
                <CommonLabel>Grades</CommonLabel>
                <Controller
                  as={Select}
                  value="value"
                  name="teachingGrades"
                  options={gradesList}
                  placeholder="Grades (Credentialed to teach)"
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={""}
                  isMulti={true}
                  closeMenuOnSelect={false}
                />
                {errors.teachingGrades && <Error>Please select Grade</Error>}
              </DropdownWrapper>
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="Qualifications"
                placeholder="Qualifications (if not a credentialed teacher, what qualifies you to teach?)"
                rows={4}
                name="qualification"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.qualification && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="Awards"
                placeholder="Awards"
                rows={4}
                name="awards"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.awards && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper>
            <div className="child only-child">
              <DropdownWrapper>
                <CommonLabel>Subject Expertise</CommonLabel>
                <Controller
                  as={Select}
                  value="value"
                  name="subjectExpertise"
                  options={subjectOptions}
                  placeholder="Subject Expertise"
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={""}
                  isMulti={true}
                  closeMenuOnSelect={false}
                />
                {errors.subjectExpertise && (
                  <Error>Please select Subject</Error>
                )}
              </DropdownWrapper>
            </div>
          </FormFlexWrapper>
        </Fragment>
      )}
      {selectedWizard === 2 && (
        <Fragment>
          <h4 className="form-header text-center mb-3">
            Additional Information
          </h4>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="How would you describe your teaching style?"
                placeholder="Type here"
                rows={6}
                autoFocus={true}
                name="teachingStyle"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.teachingStyle && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="What is your educational Philosophy?"
                placeholder="Type here"
                rows={6}
                name="educationalPhilosophy"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.educationalPhilosophy && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="Which subject is your favorite to teach and why?"
                placeholder="Type here"
                rows={6}
                name="favoriteSubject"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.favoriteSubject && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="What makes a lesson successful?"
                placeholder="Type here"
                rows={6}
                name="makesLessionSuccessful"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={
                  errors.makesLessionSuccessful && "This field is required"
                }
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper>
            <div className="child only-child">
              <Textarea
                label="How do you engage your students in a lesson?"
                placeholder="Type here"
                rows={6}
                name="engageStudentsInLession"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={
                  errors.engageStudentsInLession && "This field is required"
                }
              />
            </div>
          </FormFlexWrapper>
        </Fragment>
      )}
      {selectedWizard === 3 && (
        <Fragment>
          <h4 className="form-header text-center mb-3">Form Submission</h4>
          <FormFlexWrapper className="mb-3">
            <div className="child only-child">
              <CommonLabel className="mb-1">Choose type of Plan</CommonLabel>
              {teacherPlan.map((each: any, index: number) => (
                <>
                  <FlexWrapper className="justify-between flex-start-on-mobile mb-10">
                    <Radio
                      className="radio mb-0"
                      name="typeOfPlan"
                      value={each.value}
                      key={each.value}
                      checked={true}
                      register={register({
                        required: true,
                      })}
                      id={"plan_" + each.value}
                      label={each.label}
                    />
                    {index === 0 && planType === 'lessonPlan' &&
                      <button
                        type="button"
                        onClick={() => setShowSample(true)}
                        className="anchor-tag custom-alignment-on-moible"
                      >
                        View Sample Lesson Plan
                    </button>
                    }
                    {index === 1 && planType === 'unitPlan' &&
                      <button
                        type="button"
                        onClick={() => setShowSample(true)}
                        className="anchor-tag custom-alignment-on-moible"
                      >
                        View Sample Unit Plan
                    </button>
                    }
                  </FlexWrapper>
                </>
              ))}
              {errors.typeOfPlan && <Error>Please select type of Plan</Error>}
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <CommonLabel>Subject</CommonLabel>
              <DropdownWrapper>
                <Controller
                  as={Select}
                  value="value"
                  name="submissionSubject"
                  options={subjectOptions}
                  placeholder="Choose subject"
                  autoFocus={true}
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={""}
                />
                {errors.submissionSubject && (
                  <Error>Please select subject</Error>
                )}
              </DropdownWrapper>
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Input
                hideLabel={false}
                label="Topic"
                placeholder="Type here"
                name="submissionTopic"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.submissionTopic && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <CommonLabel>Grade</CommonLabel>
              <DropdownWrapper>
                <Controller
                  as={Select}
                  value="value"
                  name="submissionGrades"
                  options={gradesList}
                  placeholder="Grade"
                  control={control}
                  rules={{ required: true }}
                  styles={SelectCustomStyles}
                  defaultValue={""}
                  isMulti={true}
                  closeMenuOnSelect={false}
                />
                {errors.submissionGrades && <Error>Please select Grade</Error>}
              </DropdownWrapper>
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="Essential Questions"
                placeholder="What thought provoking questions will the students think about throughout this unit?"
                rows={6}
                name="essentialQuestions"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.essentialQuestions && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="Key Skills"
                placeholder="What skills will the student apply during this lesson?"
                rows={6}
                name="keySkills"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.keySkills && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="Standards"
                placeholder="What national standards does this lesson cover?"
                rows={6}
                name="submissionStandards"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.submissionStandards && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          {planType === "lessonPlan" && (
            <>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Textarea
                    label="Lesson Description"
                    placeholder="Describe your lesson with as much detail as possible..."
                    rows={6}
                    name="lessionDescription"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    error={
                      errors.lessionDescription && "This field is required"
                    }
                  />
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Textarea
                    label="Lesson Objective"
                    placeholder="What will students be able to demonstate by the end of this lesson?"
                    rows={6}
                    name="lessionObjective"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    error={errors.lessionObjective && "This field is required"}
                  />
                </div>
              </FormFlexWrapper>
            </>
          )}
          {planType === "unitPlan" && (
            <>
              {" "}
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Textarea
                    label="Lessons in the Unit"
                    placeholder="Please describe the desired outcome of this unit."
                    rows={6}
                    name="lessionDescription"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    error={
                      errors.lessionDescription && "This field is required"
                    }
                  />
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Textarea
                    label="Unit Objective"
                    placeholder="Please describe the desired outcome of this unit."
                    rows={6}
                    name="lessionObjective"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    error={errors.lessionObjective && "This field is required"}
                  />
                </div>
              </FormFlexWrapper>
            </>
          )}
          <FormFlexWrapper className="mb-0">
            <div className="child only-child">
              <Textarea
                label="What makes this special"
                placeholder="Please explain how this lesson is unique?"
                rows={6}
                name="makeThisSpecial"
                register={register({
                  required: true,
                  validate: (value: any) => {
                    return value.trim().length > 0;
                  },
                })}
                error={errors.makeThisSpecial && "This field is required"}
              />
            </div>
          </FormFlexWrapper>
          <FormFlexWrapper className="mb-3">
            <div className="child only-child">
              <button
                type="button"
                onClick={() => setShowSample(true)}
                className=" anchor-tag d-block text-center mx-auto"
              >
                {planType === "lessonPlan"
                  ? "View Sample Lesson Plan"
                  : "View Sample Unit Plan"}
              </button>
            </div>
          </FormFlexWrapper>
        </Fragment>
      )}
      {showSample && (
        <SampleFile planType={planType} onClose={() => setShowSample(false)} />
      )}
    </Fragment>
  );
}
